import React from 'react';
import PropTypes from 'prop-types';

import { ChapterPage } from '../../partials';

export const CorneringContentChapter = ({ name }) => (
  <ChapterPage title={name}>
    <p>
      Let&rsquo;s get back to basics! This section shows you how to place
      content in the corners of a container.
    </p>
  </ChapterPage>
);

CorneringContentChapter.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/chapters/CorneringContentChapter.js